import React, { useEffect } from 'react';
import styled from 'styled-components';

import {
  DESKTOP_OFFSET_AFTER_HEADER,
  FULL_MOBILE_OFFSET,
  HEADER_OFFSET_SEARCH,
  countFullDesktopOffset,
} from 'src/constants/header';

import type { PropsFromRedux } from '.';
import MapboxSearch from '../MapboxSearch';
import ExpandControl from './components/ExpandControl';
import Popup from './components/Popup';

/**
 * Контейнер для загрузки карты
 */
export const MapContainer = (props: PropsFromRedux) => {
  const {
    isMobile,
    hotelsList,
    regionsList,
    mapPosition,
    activeHotel,
    getMapDataHandler,
    setPopupDataHandler,
    isHotelCardOpened,
    getImages,
    isHeaderBannerHidden,
  } = props;

  useEffect(() => {
    getMapDataHandler();
  }, [getMapDataHandler]);

  if (!mapPosition) {
    return null;
  }

  return (
    <StyledMapboxSearch
      isMobile={isMobile}
      hotelsList={hotelsList}
      regionsList={regionsList}
      mapPosition={mapPosition}
      activeHotel={activeHotel}
      setPopupDataHandler={setPopupDataHandler}
      getImages={getImages}
      isHotelCardOpened={isHotelCardOpened}
      isHeaderBannerHidden={!!isHeaderBannerHidden}
    >
      <>
        <Popup />
        <ExpandControl />
      </>
    </StyledMapboxSearch>
  );
};

const StyledMapboxSearch = styled(MapboxSearch)<{
  isMobile: boolean;
  isHeaderBannerHidden: boolean;
}>`
  height: calc(
    100vh -
      ${({ isMobile, isHeaderBannerHidden }) =>
        isMobile
          ? FULL_MOBILE_OFFSET
          : countFullDesktopOffset(isHeaderBannerHidden)}px
  );
  top: ${({ isMobile }) =>
    isMobile ? 0 : HEADER_OFFSET_SEARCH + DESKTOP_OFFSET_AFTER_HEADER}px;
  position: ${({ isMobile }) => (isMobile ? 'relative' : 'sticky')} !important;
  font-family: 'Backpack', 'Helvetica', 'sans-serif';
`;
